<template>
    <div>
        <b-row>
            <b-col md="12">
                <div class="table-responsive">
                    <table class="table-sm">
                        <tbody>
                            <tr class="table-secondary text-uppercase">
                                <th colspan="4">
                                    INFORMACIÓN GENERAL
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    Estado
                                </th>
                                <td class="text-uppercase">
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.estado_runt
                                    }}
                                </td>
                                <th>
                                    Placa
                                </th>
                                <td class="text-uppercase">
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.placa
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Tipo de vehiculo
                                </th>
                                <td class="text-uppercase">
                                    {{ inspeccionlegal.vehiculo.tipo_vehiculo }}
                                </td>
                                <th>
                                    Marca
                                </th>
                                <td class="text-uppercase">
                                    {{ inspeccionlegal.vehiculo.marca }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Linea
                                </th>
                                <td class="text-uppercase">
                                    {{ inspeccionlegal.vehiculo.linea }}
                                </td>
                                <th>
                                    Modelo
                                </th>
                                <td>
                                    {{ inspeccionlegal.vehiculo.modelo }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Versión
                                </th>
                                <td colspan="3" class="text-uppercase">
                                    {{ inspeccionlegal.vehiculo.version }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Kilometraje
                                </th>
                                <td>
                                    {{
                                        numberWithoutDots(
                                            inspeccionlegal.kilometraje
                                        )
                                    }}
                                    km
                                </td>
                                <th>
                                    Color
                                </th>
                                <td class="text-uppercase">
                                    {{ inspeccionlegal.color }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Matriculado en
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.transito.ciudad
                                    }}
                                </td>
                                <th>
                                    Fecha de Matricula
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.fecha_matricula
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Nro. Motor
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.numero_motor
                                    }}
                                </td>
                                <th>
                                    Nro. Chasis
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.numero_chasis
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Nro. Serial
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.numero_serial
                                    }}
                                </td>
                                <th>
                                    Nro. VIN
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.numero_vin
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Unico Dueño
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.unico_dueno
                                    }}
                                </td>
                                <th>
                                    Nro. de Propietarios
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.cant_dueno
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Codigo Fasecolda
                                </th>
                                <td>
                                    {{ inspeccionlegal.vehiculo.cod_fasecolda }}
                                </td>
                                <th>
                                    Vr. Asegurable
                                </th>
                                <td>
                                    $
                                    {{
                                        numberWithDots(inspeccionlegal.vrFasecolda)
                                    }}
                                </td>
                            </tr>
                           <!--  <tr>
                                <th>
                                    Peritaje
                                </th>
                                <td colspan="3"></td>
                            </tr> -->
                            <tr class="table-secondary text-uppercase">
                                <th colspan="4">
                                    Especificaciones Técnicas
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    Tipo de Caja
                                </th>
                                <td>
                                    {{
                                        get_tipo_caja(
                                            inspeccionlegal.vehiculoData
                                                .tipo_caja
                                        )
                                    }}
                                </td>
                                <th>
                                    Carroceria
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.carroceria
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Cilindraje
                                </th>
                                <td>
                                    {{
                                        numberWithoutDots(
                                            inspeccionlegal.vehiculoData
                                                .clindraje
                                        )
                                    }}
                                    cc
                                </td>
                                <th>
                                    Combustible
                                </th>
                                <td>
                                    {{
                                        get_combustible(
                                            inspeccionlegal.vehiculoData
                                                .combustible
                                        )
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Puertas
                                </th>
                                <td>
                                    {{ inspeccionlegal.vehiculoData.puertas }}
                                </td>
                                <th>
                                    Capacidad
                                </th>
                                <td>
                                    {{ inspeccionlegal.vehiculoData.capacidad }}
                                    pasajeros
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Potencia
                                </th>
                                <td>
                                    {{ inspeccionlegal.vehiculoData.potencia }}
                                    hp
                                </td>
                                <th>
                                    Tracción
                                </th>
                                <td>
                                    {{
                                        inspeccionlegal.vehiculoData.transmision
                                    }}
                                </td>
                            </tr>
                            <tr class="table-secondary">
                                <th colspan="4">
                                    SOAT
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    Estado
                                </th>
                                <th>
                                    Fecha
                                </th>
                                <th colspan="2">
                                    Entidad que expide
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.estado_soat
                                    }}
                                </td>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.fecha_soat
                                    }}
                                </td>
                                <td colspan="2">
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.entidad_soat
                                    }}
                                </td>
                            </tr>
                            <tr class="table-secondary">
                                <th colspan="4">
                                    REVISIÓN TÉCNICO MECÁNICA
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    Estado
                                </th>
                                <th>
                                    Fecha
                                </th>
                                <th colspan="2">
                                    Entidad que expide
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.estado_tecnicomecanica
                                    }}
                                </td>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.fecha_tecnicomecanica
                                    }}
                                </td>
                                <td colspan="2">
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.entidad_tecnicomecanica
                                    }}
                                </td>
                            </tr>
                            <tr class="table-secondary">
                                <th colspan="4">
                                    BLINDAJE
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    Nivel
                                </th>
                                <th>
                                    Fecha
                                </th>
                                <th colspan="2">
                                    Empresa
                                </th>
                            </tr>
                            <tr
                                v-if="
                                    inspeccionlegal.inspeccionlegalData.vehiculo
                                        .estado_blindaje == 'No'
                                "
                                style="text-align: center;"
                            >
                                <td colspan="4">
                                    El vehículo no registra blindaje
                                </td>
                            </tr>
                            <tr v-else>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.tipo_blindaje
                                    }}
                                </td>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.fecha_blindaje
                                    }}
                                </td>
                                <td colspan="2">
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.empresa_blindaje
                                    }}
                                </td>
                            </tr>
                            <tr class="table-secondary">
                                <th colspan="4">
                                    LIMITACIONES A LA PROPIEDAD
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    Situacion
                                </th>
                                <th>
                                    Vr. Deuda
                                </th>
                                <th colspan="2">
                                    Entidad Bancaria
                                </th>
                            </tr>
                            <tr
                                v-if="
                                    inspeccionlegal.inspeccionlegalData.vehiculo
                                        .estado_limitacion == 'Libre'
                                "
                                style="text-align: center;"
                            >
                                <td colspan="4">
                                    El vehículo no registra limitaciones
                                </td>
                            </tr>
                            <tr v-else>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.estado_limitacion
                                    }}
                                </td>
                                <td>
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.valor_limitacion
                                    }}
                                </td>
                                <td colspan="2">
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.entidad_limitacion
                                    }}
                                </td>
                            </tr>
                            <tr class="table-secondary">
                                <th colspan="4">
                                    HISTORIAL DE RECLAMACIONES
                                </th>
                            </tr>
                            <tr>
                                <th colspan="2">
                                    Fecha de Siniestro
                                </th>
                                <th colspan="2">
                                    Tipo de Siniestro
                                </th>
                            </tr>
                            <tr
                                v-if="
                                    inspeccionlegal.ReclamacionesData.length ===
                                        0
                                "
                                style="text-align: center;"
                            >
                                <td colspan="4">
                                    El vehículo no registra reclamaciones
                                </td>
                            </tr>
                            <tr
                                v-for="(item,
                                index) in inspeccionlegal.ReclamacionesData"
                                :key="index"
                            >
                                <td colspan="2">
                                    {{ item.fecha_siniestro }}
                                </td>
                                <td colspan="2">
                                    {{ item.tipo_siniestro }}
                                </td>
                            </tr>
                            <tr class="table-secondary">
                                <th colspan="4">
                                    MERCADEO
                                </th>
                            </tr>
                            <tr>
                                <th>Redautos</th>
                                <td colspan="3">
                                    <a
                                        :href="
                                            inspeccionlegal.mercadeoData
                                                .link_redautos
                                        "
                                        target="blank"
                                        >{{
                                            inspeccionlegal.mercadeoData
                                                .link_redautos
                                        }}</a
                                    >
                                </td>
                            </tr>
                            <tr>
                                <th>Tucarro</th>
                                <td colspan="3">
                                    <a
                                        :href="
                                            inspeccionlegal.mercadeoData
                                                .link_tucarro
                                        "
                                        target="blank"
                                        >{{
                                            inspeccionlegal.mercadeoData
                                                .link_tucarro
                                        }}</a
                                    >
                                </td>
                            </tr>
                            <tr>
                                <th>El Pais</th>
                                <td colspan="3">
                                    <a
                                        :href="
                                            inspeccionlegal.mercadeoData
                                                .link_elpais
                                        "
                                        target="blank"
                                        >{{
                                            inspeccionlegal.mercadeoData
                                                .link_elpais
                                        }}</a
                                    >
                                </td>
                            </tr>
                            <tr>
                                <th>Facebook</th>
                                <td colspan="3">
                                    <a
                                        :href="
                                            inspeccionlegal.mercadeoData
                                                .link_marketplace
                                        "
                                        target="blank"
                                        >{{
                                            inspeccionlegal.mercadeoData
                                                .link_marketplace
                                        }}</a
                                    >
                                </td>
                            </tr>
                            <tr>
                                <th>Instagram</th>
                                <td colspan="3">
                                    <a
                                        :href="
                                            inspeccionlegal.mercadeoData
                                                .link_instagram
                                        "
                                        target="blank"
                                        >{{
                                            inspeccionlegal.mercadeoData
                                                .link_instagram
                                        }}</a
                                    >
                                </td>
                            </tr>
                            <tr class="table-secondary">
                                <th colspan="4">
                                    OBSERVACIONES
                                </th>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    {{
                                        inspeccionlegal.inspeccionlegalData
                                            .vehiculo.observaciones
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import helper from "helpers/main-helper";

export default {
    props: ["inspeccionlegal"],
    methods: {
        numberWithDots(string) {
            return helper.numberWithDots(string);
        },
        numberWithoutDots(string) {
            return helper.numberWithoutDots(string);
        },
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Tiptronic";
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
